import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import Linkify from "react-linkify"; //Material imports

import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import ClampedDialogueBody from "./ClampedDialogueBody";
export var useDialogueBodyStyles = makeStyles({
  linkify: {
    display: "flex"
  },
  dialogueBody: {
    wordWrap: "break-word",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
    wordBreak: "break-word"
  }
});

var DialogueBody = function DialogueBody(_ref) {
  var body = _ref.body,
      textStyling = _ref.textStyling,
      lineClamp = _ref.lineClamp,
      linkify = _ref.linkify,
      rest = _objectWithoutProperties(_ref, ["body", "textStyling", "lineClamp", "linkify"]);

  var classes = useDialogueBodyStyles();
  var child = lineClamp ? /*#__PURE__*/React.createElement(ClampedDialogueBody, Object.assign({
    body: body,
    textStyling: textStyling
  }, rest)) : /*#__PURE__*/React.createElement(Typography, {
    classes: {
      root: textStyling
    },
    component: "div",
    tabIndex: "0",
    className: classes.dialogueBody
  }, body);

  if (!linkify) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.linkify
    }, child);
  }

  return /*#__PURE__*/React.createElement(Linkify, {
    properties: {
      target: "_blank",
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    },
    className: classes.linkify
  }, child);
};

export default DialogueBody;
DialogueBody.defaultProps = {
  textStyling: "",
  lineClamp: false,
  linkify: true
};